
import {defineComponent, ref, PropType, watch} from "vue";

export default defineComponent({
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    mode:{
      type:Number,
      required:false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    minimumBuyableAmount: {
      type: Number,
      required: false
    },
    maximumBuyableAmount: {
      type: Number,
      required: false
    },
    productType: {
      type: String,
      required: false
    },
    unitType: {
      type: String,
      required: false
    }
  },
  emits: {
    "update:modelValue" (value: number): boolean {
      return !isNaN(value);
    }
  },

  setup(props, context) {
    const modelNumber = ref<number>(
      props.minimumBuyableAmount && props.modelValue < props.minimumBuyableAmount ? props.minimumBuyableAmount : props.modelValue
    );

    const onAddOne = (): void => {
      if (modelNumber.value == 1.5) {
        modelNumber.value += 0.5
      } else {
        modelNumber.value += 1;
      }

      context.emit("update:modelValue", modelNumber.value);
    };

    const onSubtractOne = (): void => {
      if (modelNumber.value == 2 && props.minimumBuyableAmount == 1.5) {
        modelNumber.value -= 0.5;
      } else {
        modelNumber.value -= 1
      }

      context.emit("update:modelValue", modelNumber.value);
    };

    const onChange = (e: InputEvent) => {
      let value = Number((e.currentTarget as HTMLInputElement).value);

      if (isNaN(value)) {
        context.emit("update:modelValue", 1);
      }
      else{
        if (props.unitType !== "kg" && /\D/.test(value.toString())) {
          const roundedValue = Math.round(value);
          modelNumber.value = roundedValue;
          value = roundedValue;
        } else if (props.unitType === "kg" && /\D/.test(value.toString())) {
          const roundedValue = Math.round(value * 10) / 10;
          modelNumber.value = roundedValue;
          value = roundedValue;
        }

        if (props.maximumBuyableAmount && value > props.maximumBuyableAmount) {
            modelNumber.value = props.maximumBuyableAmount;
        } else if (props.minimumBuyableAmount && value < props.minimumBuyableAmount) {
          modelNumber.value = props.minimumBuyableAmount;
        } else {
          modelNumber.value = value;
        }

        if (value < 1 && !props.minimumBuyableAmount) {
          modelNumber.value = 1;
        }

        if (e.currentTarget) {
          //Needed to update the input field for some reason
          (e.currentTarget as HTMLInputElement).value = modelNumber.value.toString()
        }
          context.emit("update:modelValue", modelNumber.value);
      }
    };

    return {
      modelNumber,
      onAddOne,
      onSubtractOne,
      onChange,
    }
  }
});
